import { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  Tooltip,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  Typography,
  Stack,
  Chip,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { ISingleRenewalApplication } from 'src/Types/module/applications/applications';
import MultipleAndSingleImgValidateWithPreview from 'src/common/FileValidation/MultipleAndSingleImgValidateWithPreview';
import moment from 'moment';
import axios from 'axios';
import { url } from 'src/Helpers/utils/Constant';
import Toaster from 'src/Toaster/Toaster';
import { IResponse } from 'src/basic-rest/types';
import { HttpClient } from 'src/Helpers/http/http';
import { useParams } from 'react-router-dom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
type IProps = {
  application: ISingleRenewalApplication;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setApplication: React.Dispatch<
    React.SetStateAction<ISingleRenewalApplication>
  >;
};

const UpdateRenewalApplication = ({
  application,
  setShowModal,
  setApplication,
}: IProps) => {
  const Toast = Toaster();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors, touchedFields },
    watch,
    getValues,
    reset,
  } = useForm<any>({
    defaultValues: {},
  });

  const isStatusReject = watch('renewal_application_status');
  useEffect(() => {
    reset({
      ...application,
      renewal_application_status: 'pending',
      civil_aviation_issue_date: moment(
        application?.civil_aviation_issue_date
      ).format('YYYY-MM-DD'),
      civil_aviation_expiry_date: moment(
        application?.civil_aviation_expiry_date
      ).format('YYYY-MM-DD'),
      trade_license_issue_date: moment(
        application?.trade_license_issue_date
      ).format('YYYY-MM-DD'),
      trade_license_expiry_date: moment(
        application?.trade_license_expiry_date
      ).format('YYYY-MM-DD'),
    });
  }, [application]);
  const [loading, setLoading] = useState(false);
  const onSubmit = async (value: any) => {
    const formData = new FormData();

    const touchedValues = Object?.keys(touchedFields)?.reduce(
      (acc, key) => {
        acc[key] = getValues(key);
        return acc;
      },
      {} as Record<string, any>
    );
    if (Object?.keys(touchedValues)?.length) {
      Object?.keys(touchedValues)?.forEach((key) => {
        if (
          touchedValues[key] instanceof FileList ||
          Array.isArray(touchedValues[key])
        ) {
          const file = touchedValues[key][0];
          if (file) {
            formData.append(key, file);
          }
        } else {
          formData.append(key, touchedValues[key]);
        }
      });

      try {
        const res: IResponse = await HttpClient.patch(
          `${url}/api/member/renewal-application/${application.renewal_application_id}`,
          formData
        );

        if (res.success) {
          Toaster().fire({
            icon: 'success',
            title: res.message,
          });
          const data = await axios.get(
            `${url}/api/member/renewal-application/${id}`
          );
          if (data?.data?.success) {
            setApplication(data.data.data);
          }
          setShowModal(false);
          reset({});
        }
      } catch (err: any) {
        Toaster().fire({
          icon: 'error',
          title: err?.response?.data.message,
        });
      }
    } else {
      Toast.fire({
        icon: 'error',
        title: `Change field first`,
      });
    }
  };

  return (
    <>
      <Box component='form' onSubmit={handleSubmit(onSubmit)} p={0}>
        <Grid container spacing={2} mb={2} maxWidth={'md'}>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Updated civil aviation file ( max size 5mb )'
              fieldName={`renewal_application_updated_civil_aviation_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.renewal_application_updated_civil_aviation_file,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Updated trade license file ( max size 5mb )'
              fieldName={`renewal_application_updated_trade_license_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.renewal_application_updated_trade_license_file,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label={
                <Tooltip title='Proof of Submission of Tax Return (Acknowledgement Receipts) (max size 5mb)'>
                  <span style={{ cursor: 'pointer' }}>
                    Proof of Submission of Tax Return (Acknowledgement Receipts)
                    (max size 5mb)
                  </span>
                </Tooltip>
              }
              fieldName={`renewal_application_tax_return_certificate_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.renewal_application_tax_return_certificate_file,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Previous Certificate file from ATAB ( max size 5mb )'
              fieldName={`renewal_application_prev_atab_certificate_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.renewal_application_prev_atab_certificate_file,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <a
              href='https://m360ict.s3.ap-south-1.amazonaws.com/uploads/UploadedFiles/underTakingFile/undertaking_form(2).doc'
              download='undertaking_form.doc'
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                textDecoration: 'none',
                backgroundColor: '#f2f5ef',
                color: '#573d3d',
                padding: '14px 20px',
                borderRadius: '8px',
                border: '1px solid #d3cece',
                fontSize: '15px',
                fontWeight: 'initial',
              }}
            >
              <DownloadIcon style={{ marginRight: '10px', color: 'green' }} />
              Download Undertaking Form
            </a>
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Undertaking File (Max size 5mb)'
              fieldName={`under_taking_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[application?.under_taking_file]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Office Deed (Max size 5mb)'
              fieldName={`office_deed_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[application?.office_deed_file]}
            />
          </Grid>
          {application?.company_ownership_status === 'Incorporated' && (
            <>
              <Grid xs={12} md={4} lg={4} item>
                <MultipleAndSingleImgValidateWithPreview
                  mt={'0'}
                  fileLimitSize={5}
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Ltd. Co. all Docs (latest)'
                  fieldName={`ltd_docs`}
                  hideCustomLabel
                  mode='single'
                  imgSerUrl={[application?.ltd_docs]}
                />
              </Grid>
              <Grid xs={12} md={4} lg={4} item>
                <MultipleAndSingleImgValidateWithPreview
                  mt={'0'}
                  fileLimitSize={5}
                  register={register}
                  clearErrors={clearErrors}
                  setError={setError}
                  errors={errors}
                  label='Schedule 10/12'
                  fieldName={`schedule_10_12`}
                  hideCustomLabel
                  mode='single'
                  imgSerUrl={[application?.schedule_10_12]}
                />
              </Grid>
            </>
          )}
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Civil Aviation Certificate Number'
              required
              id='outlined-required'
              placeholder='Civil aviation number'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('civil_aviation_number')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Civil Aviation Certificate Issue Date'
              required
              id='outlined-required'
              placeholder='Civil Aviation Certificate Issue Date'
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('civil_aviation_issue_date')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Civil Aviation Certificate Expiry Date'
              required
              id='outlined-required'
              placeholder='Civil Aviation Certificate Expiry Date'
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('civil_aviation_expiry_date')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Trade License Certificate Number'
              required
              id='outlined-required'
              placeholder='Trade License Certificate Number'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('trade_license_number')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Trade License Certificate Issue date'
              required
              id='outlined-required'
              placeholder='Trade License Certificate Issue date'
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('trade_license_issue_date')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Trade License Certificate Expiry Date'
              required
              id='outlined-required'
              placeholder='Trade License Certificate Expiry Date'
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('trade_license_expiry_date')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Tin Number'
              required
              id='outlined-required'
              placeholder='Tin Number'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('tin_number')}
            />
          </Grid>
          <Grid xs={12} item>
            <Alert severity='error' icon={<DownloadIcon />}>
              Note: Download the undertaking form then fillup and Upload.
            </Alert>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id='demo-simple-select-label'>
                Select Status
              </InputLabel>
              <Select
                {...register('renewal_application_status')}
                labelId='demo-simple-select-label'
                label='Ownership status'
                defaultValue={application?.renewal_application_status}
              >
                <MenuItem value='pending'>Pending</MenuItem>
                <MenuItem value='approved'>Approved</MenuItem>
                <MenuItem value='rejected'>Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {(isStatusReject === 'rejected' ||
            (application?.renewal_application_reject_reason &&
              application.renewal_application_status === 'rejected')) && (
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  placeholder='Write reason....'
                  id='outlined-basic'
                  label='Note'
                  variant='outlined'
                  {...register('renewal_application_reject_reason')}
                  multiline
                  type='text'
                  rows={3}
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>

        <Box mt={5}>
          {!loading ? (
            <Button
              type='submit'
              fullWidth
              variant='contained'
              disableElevation
            >
              Submit
            </Button>
          ) : (
            <LoadingButton
              loading
              loadingIndicator='Loading...'
              variant='contained'
              fullWidth
              disabled
            >
              <span>Loading...</span>
            </LoadingButton>
          )}
        </Box>
      </Box>
    </>
  );
};

export default UpdateRenewalApplication;
